module.exports = __webpack_public_path__ + "static/media/Trinidad Dr, Tiburon, CA5.c8efe146.jpg";